import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpCenterService } from '../help-center-article.service';
import { HelpCenterCategoryService } from '../../help-center-category/help-center-category.service';

import * as QuillNamespace from 'quill';
let Quill: any = QuillNamespace;
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageResize', ImageResize);


@Component({
  selector: 'ngx-show-help-article-category',
  templateUrl: 'show-help-center-article.component.html',
  styleUrls: ['show-help-center-article.component.scss'],
})
export class ShowHelpCenterArticleComponent implements OnInit {

  public article: any = {};
  public parentId = '';

  htmlText = "<p>Testing</p>"

  public result;

  articleContent;

  amountViewAll = 0;

  registerForm: FormGroup;
  submitted = false;
  dropdownSettings = {};
  categories: any[];
  categoritySelected: any[];

  articleUsers: any = [];
  articleUsersReactions;
  articleUsersReactionsSad;
  articleUsersReactionsNeutral;
  articleUsersReactionsHappy;

  options = [
    { value: 'DRAFT', label: 'Rascunho' },
    { value: 'PUBLISHED', label: 'Publicado' },
  ];

  settingsUserView = {
    actions: false,
    mode: 'external',
    columns: {
      name: {
        title: 'Nome do usuário',
        type: 'string',
      },
      amountViewAll: {
        title: 'Vezes visualizados',
        type: 'number',
      },
      dateView: {
        title: 'Data da ultima visualização',
        type: 'string',
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  settingsUserReaction = {
    actions: false,
    mode: 'external',
    columns: {
      name: {
        title: 'Nome do usuário',
        type: 'string',
      },
      dateView: {
        title: 'Data da ultima visualização',
        type: 'string',
      },
      custom: {
        title: 'Reação',
        type: 'html',
        filter: false,
        valuePrepareFunction: (colunmValue, rowValue) => {
          const status = rowValue.status;
          if (!status) {
            return '';
          }
          const imgRuim = '<img src="assets/images/SVG/ruim.svg" width="22" alt="Ruim" title="Ruim"> </img>';
          const imgBom = '<img src="assets/images/SVG/bom.svg" width="22" alt="Bom" title="Bom">  </img>';
          const imgExelente = '<img src="assets/images/SVG/excelente.svg" width="22" alt="Excelente"' +
            ' title="Excelente"></img>';

          if (status === 'SAD') {
            return imgRuim;
          }
          if (status === 'HAPPY') {
            return imgExelente;
          }
          if (status === 'NEUTRAL') {
            return imgBom;
          }
        },
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  editor_modules;

  constructor(private route: ActivatedRoute,
    private toastrService: NbToastrService, private router: Router,
    private helpCenterService: HelpCenterService,
    private formBuilder: FormBuilder,
    private helpCenterCategoryService: HelpCenterCategoryService) {
    this.parentId = this.route.snapshot.params.parentId;
    this.getModule(this.parentId);
    this.getAllCategories();

    this.editor_modules = {
      imageResize: true
    };

    this.dropdownSettings = {
      singleSelection: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      idField: 'id',
      textField: 'name',
      searchPlaceholderText: 'Localizar',
      allowSearchFilter: true,
      closeDropDownOnSelection: false,
    };
  }

  getAllCategories() {
    this.helpCenterCategoryService.query().toPromise().then(result => {
      this.categories = result.body;
    });
  }

  getUsersReations(reation) {
    this.articleUsersReactions = [];
    if (reation === '') {
      for (let i = 0; i < this.articleUsers.length; i++) {
        const element = this.articleUsers[i];
        if (element.status) {
          this.articleUsersReactions.push(element);
        }
      }
    } else {
      for (let i = 0; i < this.articleUsers.length; i++) {
        const element = this.articleUsers[i];
        if (element.status === reation) {
          this.articleUsersReactions.push(element);
        }
      }
    }


  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      category: ['', Validators.required],
    });

    // setTimeout(() => {
    //   this.articleContent = `<p>Hello world</p>`;
    // }, 500);

  }

  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  onEditorCreated(event) {
    if (this.article.text) {
      event.root.innerHTML = this.article.text;
    }
  }


  onContentChanged = (event) => {
    this.article.text = event.html;
  }

  getModule(parentId) {
    if (parentId === 'create') {
      this.article = {};
      this.article.status = 'DRAFT';
    } else {
      this.helpCenterService.findShow(this.parentId).toPromise().then(response => {
        this.result = response.body;
        this.article = this.result.helpCenter;
        this.categoritySelected = [];
        this.categoritySelected.push(this.article.category);

        this.helpCenterService.findShowUsers(this.parentId).toPromise().then(result => {
          this.articleUsers = result.body;
          for (let index = 0; index < this.articleUsers.length; index++) {
            const element = this.articleUsers[index];
            if (element.amountViewAll) {
              this.amountViewAll = this.amountViewAll + element.amountViewAll;
            }
          }
        });

      });
    }
  }

  goBack() {
    this.router.navigate(['pages/admin/help-center-article']);
  }

  getCategorySelected() {
    for (let i = 0; i < this.categories.length; i++) {
      const element = this.categories[i];
      if (element.id === this.categoritySelected[0].id) {
        this.article.category = element;
      }
    }
  }

  save() {
    this.getCategorySelected();
    this.helpCenterService.create(this.article).toPromise().then(response => {
      this.toastrService.show('Artigo', 'Salvo com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.router.navigate(['pages/admin/help-center-article']);
    }).catch(err => {
      this.toastrService.show('Artigo', err.error.detail,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

}
